export default {
    config: {
        defaultWidth: 80
    },
    default: {
        label: 'Rank'
    },
    unique: [],
    sort: 'rank',
    lang: {
        name: 'Rank',
        category: 'BGG',
        description: 'Community ranking of the game.',
        views: ['list', 'sheet', 'grid'],
    },
    filters: ['bgg.rank']
}